import { render } from "./JobManagementList.vue?vue&type=template&id=4c293aa8&scoped=true&ts=true"
import script from "./JobManagementList.vue?vue&type=script&lang=ts"
export * from "./JobManagementList.vue?vue&type=script&lang=ts"

import "./JobManagementList.vue?vue&type=style&index=0&id=4c293aa8&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c293aa8"]])

export default __exports__